import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonAsLink } from '../../../ButtonAsLink';
export var WebStoryLink = function (_a) {
  var children = _a.children,
    url = _a.url;
  var webStoryId = url.split('/').pop();
  var WebStoriesEvent = new CustomEvent('webStoriesLinkClick', {
    detail: {
      id: webStoryId
    }
  });
  return _jsx(ButtonAsLink, {
    role: "primary",
    onClick: function () {
      return dispatchEvent(WebStoriesEvent);
    },
    children: children
  });
};